import React, { useState, useContext } from 'react';

import clsx from 'clsx';

import { routes } from '@routes';

import { link } from '@utils/link';
import { messageIdConcat } from '@utils/message-id-concat';

import { Text, Icon } from '@atoms';
import { Button } from '@molecules/button';

import { RootContext } from '@modules/base/root/root-context';

import classes from './survey-reminder.module.scss';

const m = messageIdConcat('survey.reminder');

type Props = {
  isAllowed: boolean;
};

export const SurveyReminder = ({ isAllowed }: Props) => {
  const [isClose, setIsClose] = useState(false);
  const { reminderVisible, reminderToggle } = useContext(RootContext);

  const reminderClose = () => {
    setIsClose(!isClose);
    reminderToggle(false);
  };

  if (!isAllowed || !reminderVisible) {
    return null;
  }

  return (
    <div className={clsx(classes.container, isClose && classes.closed)}>
      <Icon
        icon="close"
        className={classes.iconClose}
        onClick={() => reminderClose()}
      />
      <div className={classes.mobileClose} onClick={() => reminderClose()}>
        <Text
          message={{ id: m('close') }}
          type="small"
          color="big_stone"
          margin={[2, 0, 0]}
        />
      </div>

      <div className={classes.inner}>
        <Icon icon="reminder" className={classes.iconReminder} />
        <Text
          message={{ id: m('text1') }}
          type="reduced"
          color="big_stone"
          className={classes.textFirst}
        />
        <Text
          message={{ id: m('text2') }}
          margin={[0, 20, 0, 0]}
          type="reduced"
          color="big_stone"
          className={classes.textSecond}
        />
        <Button
          type="primary"
          size="small"
          message={{ id: m('button') }}
          link={link(routes.estimateSurvey)}
          gtm-button-id="form-return"
        />
      </div>
    </div>
  );
};
